module.exports = __webpack_public_path__ + "b9215f33d19dfb4f24f87fbbe3ec2ab5.pdf";